<footer>
  <div class="fg">
    <div>
      <div class="fl"><img src="/logo-footer-light.webp" alt="TriStar Finance" loading="lazy" width="694" height="234"></div>
      <p class="fa">Situated in Kirkland, Washington, TriStar Finance crafts personalized mortgage solutions backed by a nationwide network of capital resources. NMLS ID #43583.</p>
      <div class="ft-tags"><span class="ft-tag">Equal Housing Lender</span><span class="ft-tag">SSL Secured</span><span class="ft-tag">CFPB</span><span class="ft-tag">AWS</span></div>
    </div>
    <div class="fc3"><h4>Loan Options</h4><ul>
      <li><a routerLink="/loans/fixed-rate-mortgage">Fixed Rate Mortgage</a></li>
      <li><a routerLink="/loans/fha-home-loan">FHA Home Loan</a></li>
      <li><a routerLink="/loans/va-home-loan">VA Home Loan</a></li>
      <li><a routerLink="/loans/jumbo-home-loan">Jumbo Home Loan</a></li>
      <li><a routerLink="/heloc">HELOC</a></li>
      <li><a routerLink="/loans/usda-loan">USDA Loan</a></li>
      <li><a routerLink="/loans/dscr-loan">DSCR Loan</a></li>
      <li><a routerLink="/loans/non-qm-loan">NON-QM Loan</a></li>
      <li><a routerLink="/products">View All 19+ →</a></li>
    </ul></div>
    <div class="fc3"><h4>Company</h4><ul>
      <li><a routerLink="/about">About Us</a></li>
      <li><a routerLink="/team">Meet Our Team</a></li>
      <li><a routerLink="/where-we-lend">Where We Lend</a></li>
      <li><a routerLink="/careers">Careers</a></li>
      <li><a routerLink="/reviews">Reviews</a></li>
      <li><a routerLink="/blog">Blog</a></li>
      <li><a routerLink="/partners">Partners</a></li>
      <li><a routerLink="/training">Training</a></li>
      <li><a routerLink="/licensing">Licensing</a></li>
    </ul></div>
    <div class="fc3"><h4>Contact</h4><ul>
      <li><a href="#">10510 Northup Way, Ste 115</a></li>
      <li><a href="#">Kirkland, WA 98033</a></li>
      <li><a href="tel:4254558497">425-455-8497</a></li>
      <li><a href="mailto:contact@tristarfinance.com">contact@tristarfinance.com</a></li>
      <li><a href="https://prod.lendingpad.com/tristar-finance-inc-/pos#/?loid=a8f59110-652e-4b1d-b5e9-4f7d4da8609e" target="_blank" rel="noopener noreferrer" style="color:rgba(91,156,245,.7)">Apply Online →</a></li>
      <li><a routerLink="/quote" style="color:rgba(91,156,245,.7)">Get A Quote →</a></li>
    </ul></div>
  </div>
  <div class="fbot">
    <p class="f-legal">© 2026 TriStar Finance, Inc. | NMLS #43583 | AK: #AK43583 | CA-DFPI: #603K695 | FL: #MLD2405 | ID: #MBL-8079 | MI: #FL0024835 | MT: #43583 | OR: #ML-5231 | TX: SML | WA: #CL-43583 | Equal Housing Opportunity. All loans subject to underwriting approval. Terms and conditions apply. Affiliated with Aris360 Real Estate.</p>
    <div class="fsoc">
      <a href="https://www.facebook.com/tsfinc" target="_blank" rel="noopener noreferrer" class="soc" aria-label="Follow TriStar Finance on Facebook">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
        </svg>
      </a>
      <a href="https://www.linkedin.com/company/tristar-finance-inc-/" target="_blank" rel="noopener noreferrer" class="soc" aria-label="Follow TriStar Finance on LinkedIn">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
          <rect x="2" y="9" width="4" height="12"></rect>
          <circle cx="4" cy="4" r="2"></circle>
        </svg>
      </a>
      <a href="https://x.com/TriStarFinance_" target="_blank" rel="noopener noreferrer" class="soc" aria-label="Follow TriStar Finance on X (Twitter)">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      </a>
      <a href="https://www.youtube.com/channel/UCNd7g77z7ln2H0XQo8u_bvw" target="_blank" rel="noopener noreferrer" class="soc" aria-label="Follow TriStar Finance on YouTube">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 0 2.5 29 29 0 0 0 1 2.83 2.78 2.78 0 0 0 1.94 2c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 0-2.83 29 29 0 0 0 0-2.5"></path>
          <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
        </svg>
      </a>
      <a href="https://www.instagram.com/tristarfinance_/" target="_blank" rel="noopener noreferrer" class="soc" aria-label="Follow TriStar Finance on Instagram">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
        </svg>
      </a>
    </div>
  </div>
</footer>
